export default __webpack_public_path__ + "static/media/REFIN_affrescati_LP_CONF_TERRA-120X120.2323790b.jpg";